// Pure helpers for walking the spending-classification tree
// (shape: { parents: [{ name, subClassifications: [{ id, mgSubClassification, mgClassification }] }] }).
// Extracted verbatim from TransactionBulkPage.vue — no behaviour change.
export function findUncategorisedId(tree) {
    const parents = Array.isArray(tree?.parents) ? tree.parents : [];
    for (const p of parents) {
        const subs = Array.isArray(p.subClassifications) ? p.subClassifications : [];
        for (const s of subs) {
            const sub = s.mgSubClassification || s.mgClassification;
            if (sub === 'Uncategorised' || sub === 'Uncategorized')
                return s.id;
        }
    }
    return null;
}
// Backend workaround: when the suggested classification is "Income > Other" but
// the transaction is a spend, swap to "General > Other". The suggestion endpoint
// returns Income/Other regardless of direction when it has no real match.
export function findGeneralOther(tree) {
    const parents = Array.isArray(tree?.parents) ? tree.parents : [];
    const general = parents.find((p) => p.name === 'General');
    if (!general)
        return null;
    const subs = Array.isArray(general.subClassifications) ? general.subClassifications : [];
    return subs.find((s) => (s.mgSubClassification || s.mgClassification) === 'Other') ?? null;
}
export function findInTreeById(id, tree) {
    const parents = Array.isArray(tree?.parents) ? tree.parents : [];
    for (const p of parents) {
        const subs = Array.isArray(p.subClassifications) ? p.subClassifications : [];
        for (const s of subs)
            if (s.id === id)
                return s;
    }
    return null;
}
